module.exports = __webpack_public_path__ + "media/images/home-bg-1616ced9fdccd654cae3c4b364cf11c8.png";